/** Editor action ids whose accelerators are owned by the native app menu on desktop. */
export const NATIVE_MENU_OWNED_ACTION_IDS: ReadonlySet<string> = new Set([
  "file.new",
  "file.open",
  "file.save",
  "file.saveAs",
  "history.undo",
  "history.redo",
  "edit.selectAll",
  "edit.copySelection",
  "edit.cutSelection",
  "edit.pasteSelection",
  "view.toggleAnimationPreviewWindow",
  "view.toggleScriptsDebugWindow",
  "view.toggleRulers",
  "view.resetZoom",
]);

export function stripNativeMenuOwnedShortcuts<T extends { id: string; shortcuts: unknown[] }>(
  actions: T[],
): T[] {
  return actions.map(action => (
    NATIVE_MENU_OWNED_ACTION_IDS.has(action.id)
      ? { ...action, shortcuts: [] }
      : action
  ));
}
